<template>
    <el-dialog :title="tit" :width="width" :visible="true" class="eldialogBox" append-to-body :close-on-click-modal="false" :before-close="handleClose">
        <slot></slot>
        <span slot="footer" class="dialog-footer" v-if="footerShowState">
            <el-button class="colseT" size="small" @click="handleClose">取 消</el-button>
            <el-button type="primary" size="small" :loading="loading" @click="handleBtn">确 定</el-button>
        </span>
    </el-dialog>
</template>

<script>
export default {
    props: {
        tit: {
            type: String,
            default: ''
        },
        width: {
            type: String,
            default: '600px'
        },
        footerShowState: {
            type: Boolean,
            default: true
        }
    },
    data() {
        return {
            loading: false
        }
    },
    methods: {
        handleBtn() {
            this.$emit('handleBtn', false)
        },
        handleClose() {
            this.$emit('handleClose', false)
        }
    }
}
</script>
<style lang="scss" scoped>
::v-deep .el-dialog__body{
    border-top: 1px solid #dedede;
    border-bottom: 1px solid #dedede;
}
</style>
